<mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">announcement</mat-icon>
            <b>Alerts</b>
        </mat-panel-title>
    </mat-expansion-panel-header>
    @if (showPrimaryLotInBlockAlert()) {
        <cb-alert-card-new type="info" message="Primary Lot in Block"> </cb-alert-card-new>
    }
    @if (showSaleLostAlert()) {
        <cb-alert-card-new type="error" message="Sale Lost - Lot Requires Cleanup">
        </cb-alert-card-new>
    }
    @if (showIsShowHomeAlert()) {
        <cb-alert-card-new type="warning" message="Lot is a show home"> </cb-alert-card-new>
    }
    @if (isJobCancelled()) {
        <cb-alert-card-new type="cancel" message="Lot is cancelled"> </cb-alert-card-new>
    }
    @if (showNoConceptAlert()) {
        <cb-alert-card-new type="warning" message="There is no Concept on this Lot">
        </cb-alert-card-new>
    }
    @if (hasIncompleteLotSpecItems) {
        <cb-alert-card-new
            type="warning"
            message="There are incomplete items on the Lot Specification"
        >
        </cb-alert-card-new>
    }
    @if (showSpecTemplateAlert()) {
        <cb-alert-card-new type="warning" message="A Spec Template needs to be applied">
        </cb-alert-card-new>
    }
    @if (hasPendingResourceConsent) {
        <cb-alert-card-new
            type="warning"
            message="Resource Consent is required for the current Design Concept"
        >
        </cb-alert-card-new>
    }
    @if (showIncompleteSpecItemAlert()) {
        <cb-alert-card-new
            type="warning"
            message="Lot Spec has incomplete lot spec item attributes"
        >
        </cb-alert-card-new>
    }
    @if (showEstimatePricingAlert()) {
        <cb-alert-card-new type="warning" message="Applied Concept has estimated Pricing Revision">
        </cb-alert-card-new>
    }
    @if (showHasOwnersCareAlert()) {
        <cb-alert-card-new type="info" message="Owner's Care Item exists on Lot Spec">
        </cb-alert-card-new>
    }
    @if (hasPendingConcept) {
        <cb-alert-card-new type="info" message="Pending Concept"> </cb-alert-card-new>
    }
    @if (showWithheldFromWebsiteAlert()) {
        <cb-alert-card-new type="warning" message="Lot withheld from website"> </cb-alert-card-new>
    }
    @if (displayNoAlertsMsg()) {
        <cb-alert-card-new type="info" message="There are no alerts to display">
        </cb-alert-card-new>
    }
</mat-expansion-panel>
